import { useContext } from 'react';
import DatePicker from "react-datepicker";

import it from 'date-fns/locale/it'; 

import "react-datepicker/dist/react-datepicker.css";
import { AuthContext } from '../../../Contexts/Auth';
import { ConfigContext } from '../../../Contexts/Config';
import { SearchReviewsContext } from "../../../Contexts/SearchReviews";
import { Navigate } from 'react-router-dom';

export default function SearchReviews(
    {   dateFrom,setDateFrom,
        dateTo,setDateTo,
        status,setStatus,
        shouldLog
    }){

    const {user} = useContext(AuthContext)   

    let {api_urls} = useContext(ConfigContext)

    const {resetReviews} = useContext(SearchReviewsContext)   
    
    const setStartDate = (newDate) => {
        shouldLog.current = true
        setDateFrom(newDate)
    }

    const setFinishDate = (newDate) => {
        shouldLog.current = true
        setDateTo(newDate)
    }

    const setNewStatus = (value) => {
        shouldLog.current = true
        setStatus(value)
    }

    const resetFilters = () =>{
        resetReviews()
        Navigate('/Reviews')
    }

    return (
        <div className="card search-filter">
            <div className="card-header">
                <h4 className="card-title mb-0">
                    Filtri Ricerca - 
                    <a href="#" onClick={resetFilters}>
                        RESET
                    </a>
                </h4>
            </div>
            <div className="card-body">
                <div className="filter-widget">
                    <h4>Dal</h4>
                    <div className="cal-icon">
                    <DatePicker
                        selected={dateFrom}
                        onChange={(newValue) => setStartDate(newValue)}
                        locale={it} // set italian locale
                        dateFormat="dd/MM/yyyy"
                        timeCaption="Time"
                        timeZone='Europe/Rome'
                        className="form-control datetimepicker"
                    />
                    </div>			
                </div>
                <div className="filter-widget">
                    <h4>Al</h4>
                    <div className="cal-icon">
                    <DatePicker
                        selected={dateTo}
                        onChange={(newValue) => setFinishDate(newValue)}
                        locale={it} // set italian locale
                        dateFormat="dd/MM/yyyy"
                        timeCaption="Time"
                        timeZone='Europe/Rome'
                        className="form-control datetimepicker"
                    />
                    </div>			
                </div>
                <div className={(user?.admin > 1) ? "filter-widget react_disable" : "filter-widget"}>
                    <h4>Voto</h4>
                    <div className="form-group search-doctor">
                        <select 
                            onChange={(ev) => setNewStatus(ev.target.value)}
                            value={status}
                            className="form-control"
                        >
                            <option value="0" key="0">Tutti</option>
                            <option value="1" key="1">1</option>
                            <option value="2" key="2">2</option>
                            <option value="3" key="3">3</option>
                            <option value="4" key="4">4</option>
                            <option value="5" key="5">5</option>   
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
}